const initailState = {
  catelogue: [],
  allSellerCatelogue: [],
  CatelogueLoading: false,
  loading: false
};

export function catelogueReducers(state = initailState, { type, payload }) {
  switch (type) {
    case "GET_CATELOG_DATA":
      return { ...state, catelogue: payload, CatelogueLoading: false };
    case "GET_ALL_SELLER_CATELOGUE":
      return { ...state, allSellerCatelogue: payload, CatelogueLoading: false };
    case "SHOW_LOADING_CATELOG":
      return { ...state, CatelogueLoading: true };
    case "HIDE_LOADING_CATELOG":
      return { ...state, CatelogueLoading: false };
    case "APPROVE_CATELOGUE":
      return { ...state, CatelogueLoading: false };
    case "APPROVE_NOT_CATELOGUE":
      return { ...state, CatelogueLoading: false };
    case "CATELOGUE_ACCPETED_LOADING":
      return { ...state, loading: true };
    case "CATELOGUE_ACCPETED_SUCCESS":
      return { ...state, loading: false };
    case "CATELOGUE_ACCPETED_FAILED":
      return { ...state, loading: false };
      case "CATELOGUE_REJECTED_LOADING":
        return { ...state, loading: true };
      case "CATELOGUE_REJECTED_SUCCESS":
        return { ...state, loading: false };
      case "CATELOGUE_REJECTED_FAILED":
        return { ...state, loading: false };
    default:
      return state;
  }
}

export const getCatelogueViewPdfReducer = (
  state = {
    catelogueViewPdfLoading: false,
    CateloguePdfUrl: null,
    downloadPdf: null,
    PdfLoading: false,
  },
  { type, payload }
) => {
  switch (type) {
    case "SHOW_LOADING_VIEW":
      return { ...state, catelogueViewPdfLoading: true, CateloguePdfUrl: null };
    case "GET_VIEW_CATELOG_DATA":
      return {
        ...state,
        CateloguePdfUrl: payload,
        catelogueViewPdfLoading: false,
      };
    case "HIDE_LOADING_CATELOG_VIEW":
      return { ...state, catelogueViewPdfLoading: false, CateloguePdfUrl: null };
    case "SHOW_LOADING_DOWNLOAD":
      return { ...state, PdfLoading: true };
    case "GET_DOWNLOAD_CATELOG_DATA":
      return { ...state, PdfLoading: false };
    case "HIDE_LOADING_CATELOG_DOWNLOAD":
      return { ...state, PdfLoading: false };
    case "DOWNLOAD_CATALOGUE_SELLER_LOADING":
      return { ...state, PdfLoading: true };
    case "DOWNLOAD_CATALOGUE_SELLER_SUCCESS":
      return { ...state, PdfLoading: false };
    case "DOWNLOAD_CATALOGUE_SELLER_FAILED":
      return { ...state, PdfLoading: false };
    default:
      return state;
  }
};




